import React from "react";
import { Link } from "react-router-dom";

function MainPage(props) {
  return (
    <div>
      <div className="album py-5 bg-light ">
        <div className="container">
          <div className="row row-cols-2 row-cols-sm-2 row-cols-md-4 g-2 banner pb-5">
            <div className="col">
              <div className="card shadow-sm ">
                <Link
                  to="/search/category/Pants"
                  className="text-decoration-none"
                >
                  <img
                    src="/img/bn_shooes_L.jpg"
                    className="card-img-top align-self-center"
                    alt="..."
                  />
                  <div className="card-body">
                    <p className="card-text text-center text-muted">Shoes</p>
                  </div>
                </Link>
              </div>
            </div>

            <div className="col">
              <div className="card shadow-sm">
                <Link
                  to="/search/category/Shirts"
                  className="text-decoration-none"
                >
                  <img
                    src="/img/bn_shirts_L.jpg"
                    className="card-img-top align-self-center"
                    alt="..."
                  />
                  <div className="card-body">
                    <p className="card-text text-center text-muted">Shirts</p>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm">
                <Link
                  to="/search/category/Pants"
                  className="text-decoration-none"
                >
                  <img
                    src="/img/bn_pants_L.jpg"
                    className="card-img-top align-self-center"
                    alt="..."
                  />
                  <div className="card-body">
                    <p className="card-text text-center text-muted">Pants</p>
                  </div>
                </Link>
              </div>
            </div>

            <div className="col">
              <div className="card shadow-sm">
                <Link to="/search/name" className="text-decoration-none">
                  <img
                    src="/img/bn_acc_L.jpg"
                    className="card-img-top align-self-center"
                    alt="..."
                  />
                  <div className="card-body">
                    <p className="card-text text-center text-muted">
                      Accessories
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="row row-cols-10 row-cols-sm-10 row-cols-md-10 pb-5 banner2 ">
            <h6 className="text-center fw-bold pb-3 pt-4">NEW AND NOW</h6>
            <Link to="/search/name">
              <picture>
                <source media="(min-width: 992px)" srcset="/img/f.jpg" />
                <img
                  src="/img/e.jpg"
                  className=" img-responsive align-self-center"
                  alt="..."
                />
              </picture>
            </Link>
          </div>

          <div>
            <div className="row row-cols-2 row-cols-sm-2 row-cols-md-2 g-2 pb-5 banner3">
              <div className="col">
                <div className="card shadow-sm ">
                  <Link to="/search/name">
                    <img
                      src="/img/q.jpg"
                      className="card-img-top mx-auto d-block"
                      alt=" "
                    />
                  </Link>
                  <div className="card-body">
                    CLASSIC WORKWEAR
                    <div className="d-flex justify-content-between align-items-center">
                      <small className=" text-secondary pt-1">
                        Chill days for cozy knits, and plenty of layers.
                      </small>
                      <Link to="/search/name">
                        <small className="text-decoration-underline  link-dark ">
                          Shop now
                        </small>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card  ">
                  <Link to="/search/name">
                    <img
                      src="/img/w.jpg"
                      className="card-img-top mx-auto d-block"
                      alt=" "
                    />
                  </Link>
                  <div className="card-body">
                    NIGHT OUT, DONE RIGHT
                    <div className="d-flex justify-content-between align-items-center">
                      <small className=" text-secondary pt-1">
                        Statement jackets,and looks that shine.
                      </small>
                      <Link to="/search/name">
                        <small className="text-decoration-underline link-dark">
                          Shop now
                        </small>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row row-cols-10 row-cols-sm-10 row-cols-md-10 pt-3 banner1">
            <h5 className="text-center fw-bold pb-3 pt-3">Featured Styles</h5>
            <Link to="/search/name">
              <picture>
                <source
                  media="(min-width: 992px)"
                  srcset="/img/banner1_L.jpg"
                />
                <img
                  src="/img/banner1_S.jpg"
                  className=" img-responsive align-self-center"
                  alt="..."
                />
              </picture>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
